module.exports = __webpack_public_path__ + "static/img/ent-detail-53.b33fa21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-53.jpg
// module id = 0pJE
// module chunks = 52